import styled from 'styled-components';

const SValidationError = styled.div`
  font-size: 16px;
  color: red;
  margin-bottom: -5px;
  white-space: nowrap;
  margin-top: 4px;
`;

export default SValidationError
